var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PersistentCollection from '../PersistentCollection';
import FeedModel from '../../models/FeedModel';
import FilterRuleContainsString from '../filters/FilterRuleContainsString';
/**
 *
 */
var FeedCollection = /** @class */ (function (_super) {
    __extends(FeedCollection, _super);
    /**
     *
     */
    function FeedCollection() {
        var _this = _super.call(this, FeedModel, true, 'FeedCollection') || this;
        _this.searchStringFilter = new FilterRuleContainsString('filterString');
        _this.filter.addRule(_this.searchStringFilter);
        return _this;
    }
    /**
     *
     * @param array
     */
    FeedCollection.prototype.addAll = function (array) {
        var _this = this;
        array.forEach(function (data) {
            if (data.providerName.toLowerCase() === 'pvh') {
                data.providerName = 'PVH';
                data.dataType = 'Pvh';
                if (_this.list.filter(function (feed) {
                    return feed.providerName.toLowerCase() === 'pvh';
                }).length <= 0) {
                    _this.add(data, false);
                }
            }
            else {
                _this.add(data, false);
            }
        });
        this.updateCache(array);
        this.update();
    };
    return FeedCollection;
}(PersistentCollection));
export default FeedCollection;
